
import UserProfile from "views/UserProfile.js";
import UltraDeposito from "views/DepositosView/Depositos.jsx";  



var routespen = [

  {
    path: "/ultradeposito",
    name: "Depósito",
    tkey: "nav.deposito",
    
    icon: "tim-icons icon-coins",
    component: UltraDeposito,
    layout: "/cliente"
  },
  {
    path: "/user-profile",
    name: "Mi Cuenta",
    tkey: "nav.cuenta",
    
    icon: "tim-icons icon-single-02",
    component: UserProfile,
    layout: "/cliente"
  },
 




]; 







export default routespen;
